import React, { useEffect } from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Box, Button, Tooltip } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import InputLabel from "@mui/material/InputLabel";
import ServerNameError from "./ServerNameError";

export default function Configurations(props) {
  const { onState, value, activeStep, handleBack, handleNext, classes } = props;
  const app = JSON.parse(value);
  const application = app.application;
   const [checkstate, setCheckstate] = React.useState({
    checkedB: false, // Ensure this is always true or false, not undefined
  });

  const [newstate, setState] = React.useState({});
  const [temporary, settemporary] = React.useState([]);
  const [temporarycount, settemporarycount] = React.useState([]);

  const handleReload = () => {
    window.location.reload();
  };

  

  const handlecheckChange = (event) => {
    const id = "isCustomized";
    setCheckstate({
      ...checkstate,
      [event.target.name]: event.target.checked,
    });
    // console.log("checkState customize", { ...checkstate, [event.target.name]: event.target.checked });

    let checkedValue = "No";
    if (event.target.checked) {
      checkedValue = "Yes"
    }
    // Update parent or global state
    onState((prevState) => ({
      ...prevState,
      [id]: checkedValue,
    }));
  };

  const [template, settemplate] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/templateview/${application}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => {settemplate(resp);
        console.log("templateview...", resp)
      })
      .catch((error) => {
        console.error(error);
      });
  }, [application]);

  const [defaulttemplate, setdefaulttemplate] = React.useState([[]]);
  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/templatevaluesview/${application}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => 
        {setdefaulttemplate(resp);
          console.log("State set with:", resp); // Log the response
        })
      .catch((error) => {
        console.error(error);
      });
  }, [application]);

  const [instancetype, setInstancetype] = React.useState([[]]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/instancetype/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((resp) => setInstancetype(resp))
      .catch((error) => {
        console.error(error);
      });
  }, []);

  

  const handleChange = (e, key) => {
    const { id, value } = e.target;

    if (key === "port") {
        setState((prevState) => ({
          ...prevState,
          [id]: [value.replace("a","65").replace("l","65").replace("l","65")],
        }));
    } else if (key === "condition") {
      if (newstate[id] && newstate[id] === "yes") {
        setState((prevState) => ({
          ...prevState,
          [id]: "no",
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          [id]: "yes",
        }));
      }
    } else {
      setState((prevState) => ({
        ...prevState,
        [id]: value,
      }));
    }
    settemporary((prevState) => ({
      ...prevState,
      [id]: value,
    }));
    if (key === "type") {
      const customID = "cpu_count";
      const instanceValue = instancetype.map((instanceCpu) => {
        if (instanceCpu.instance_type === value) {
          const cpuCount = instanceCpu.vCPUs;
          return cpuCount;
        }
        return null;
      });

      const filtered = instanceValue.filter(function (el) {
        return el != null;
      });
      
      const actual = JSON.stringify(filtered);
      const replace = actual.replace("[", "").replace("]", "");
      const parse = JSON.parse(replace);

      let temporary_id = id + "_count";
      settemporarycount((prevState) => ({
        ...prevState,
        [temporary_id]: parse,
      }));

      if (!newstate.cpu_count) {
        setState((prevState) => ({
          ...prevState,
          [customID]: parse,
        }));
      } else {
        const oldInstanceLimit = newstate.cpu_count;
        let newInstanceLimit = parseInt(oldInstanceLimit) + parseInt(parse);
        if (!temporarycount[id]) {
          setState((prevState) => ({
            ...prevState,
            [customID]: newInstanceLimit,
          }));
        } else {
          const preInstanceLimit = newstate.cpu_count;
          let count_name = id + "_count";
          let postInstanceLimit1 =
            parseInt(preInstanceLimit) - parseInt(temporarycount[count_name]);
          let postInstanceLimit2 =
            parseInt(postInstanceLimit1) + parseInt(parse);
          setState((prevState) => ({
            ...prevState,
            [customID]: postInstanceLimit2,
          }));
        }
      }
    }
  };

  const handlesetClick = () => {
    // console.log("", defaulttemplate)
    
    const id1 = "template"; // Set the template valu
    onState((prevState) => ({
      ...prevState,
      [id1]: template,
    }));

    const id = "customization";

    if (checkstate.checkedB) {
      const statevar = JSON.stringify(newstate);
      const Jsonreplace = statevar.replace(/"]/g, "]").replace(/\["/g, "[");
      const recall = JSON.parse(Jsonreplace);
      // console.log("recall information", recall);
      onState((prevState) => ({
        ...prevState,
        [id]: recall,
      }));
    } else {
      onState((prevState) => ({
        ...prevState,
        [id]: defaulttemplate,
      }));
    }
    // console.log("default template.....", defaulttemplate);
    
    handleNext();
  };

  const result = Object.values(temporary).filter(
    (array) => array.length > 0
  ).length;

  const renderFields = (template) => {
    return template.map((field) => {
      let { key, title, type, name, description } = field;
      switch (type) {
        case "text":
          return (
            <Grid item md={6} xs={12} key={name}>
              <InputLabel>{title}</InputLabel>
              <TextField
                fullWidth
                helperText={description}
                name={name}
                newvalue={key}
                id={name}
                type={type}
                onChange={(event) => handleChange(event, key)}
                required
                variant="outlined"
                InputProps={{
                  style: {
                    height: "40px",
                  },
                }}
              />
            </Grid>
          );
        case "select":
          return (
            <React.Fragment>
              {key === "type" ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.title}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : key === "option" ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {field.options.map((val) => {
                      return (
                        <React.Fragment>
                          <option value={val}>{val}</option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        case "option":
          return (
            <React.Fragment>
              {key === "condition" ? (
                <Grid item md={6} xs={12} key={name}>
                  <Typography variant="h6">{title}</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id={name}
                        onChange={(event) => handleChange(event, key)}
                        color="primary"
                      />
                    }
                    label={<Typography variant="h6"></Typography>}
                  />
                </Grid>
              ) : key === "type" &&
                newstate[field.dependsOn] === field.ostype ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.title}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : key === "storage" &&
                newstate[field.dependsOn] === field.ostype ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    type={type}
                    onChange={(event) => handleChange(event, key)}
                    required
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  />
                </Grid>
              ) : key === "port" &&
              newstate[field.dependsOn] === field.ostype ? (
              <Grid item md={6} xs={12} key={name}>
                <InputLabel>{title}</InputLabel>
                <TextField
                  fullWidth
                  helperText={description}
                  name={name}
                  newvalue={key}
                  id={name}
                  type={type}
                  onChange={(event) => handleChange(event, key)}
                  required
                  variant="outlined"
                  InputProps={{
                    style: {
                      height: "40px",
                    },
                  }}
                />
              </Grid>
            ) : (
                ""
              )}
            </React.Fragment>
          );
        case "condition":
          return (
            <React.Fragment>
              {key === "name" && newstate[field.dependsOn] === "yes" ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    type={type}
                    onChange={(event) => handleChange(event, key)}
                    required
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  />
                </Grid>
              ) : key === "storage" && newstate[field.dependsOn] === "yes" ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    type={type}
                    onChange={(event) => handleChange(event, key)}
                    required
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  />
                </Grid>
              ) : key === "type" && newstate[field.dependsOn] === "yes" ? (
                <Grid item md={6} xs={12} key={name}>
                  <InputLabel>{title}</InputLabel>
                  <TextField
                    fullWidth
                    helperText={description}
                    name={name}
                    newvalue={key}
                    id={name}
                    onChange={(event) => handleChange(event, key)}
                    required
                    select
                    SelectProps={{ native: true }}
                    variant="outlined"
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                  >
                    <option key="" value=""></option>
                    {instancetype.map((instancetype) => {
                      return (
                        <React.Fragment>
                          <option value={instancetype.instance_type}>
                            {instancetype.title}
                          </option>
                        </React.Fragment>
                      );
                    })}
                  </TextField>
                </Grid>
              ) : (
                ""
              )}
            </React.Fragment>
          );
        default:
          return (
            <div key={name}>
              <span className="red-text">
                {name} {type}
              </span>
            </div>
          );
      }
    });
  };

  const [confirmation, setconfirmation] = React.useState(false);

  const handleClickConfirmation = () => {
    setconfirmation(true);
  };

  const handleCloseConfirmation = () => {
    setconfirmation(false);
  };
  let TempkeyName = [];
  Object.keys(defaulttemplate).reduce((prev, curr, key, index) => {
    template.map((field) => {
      if (field.name === curr) {
        TempkeyName.push({
          name: field.name,
          title: field.title,
          description: field.description,
          default: field.default,
        });
      }
    });
  }, {});

  return (
    <React.Fragment>
      <Box sx={{ pb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Application Requirement
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <React.Fragment>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={checkstate.checkedB}
                  onChange={handlecheckChange}
                  name="checkedB"
                  color="secondary"
                />
              }
              label="Customize"
            />
          </Grid>
          {checkstate.checkedB ? (
            <React.Fragment>{renderFields(template)}</React.Fragment>
          ) : (
            <React.Fragment>
              {TempkeyName.map((field) => {
                return (
                  <React.Fragment>
                    <Grid item md={6} xs={12} key={field.name}>
                      <InputLabel>{field.title}</InputLabel>
                      <TextField
                        fullWidth
                        helperText={field.description}
                        name={field.name}
                        disabled
                        defaultValue={field.default}
                        variant="outlined"
                        InputProps={{
                          style: {
                            height: "40px",
                          },
                        }}
                      />
                    </Grid>
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          )}
        </React.Fragment>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          pt: 2,
        }}
      >
        <div>
          <Tooltip title="Cancel and reset this step">
            <span>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleReload}
                className={classes}
                sx={{ borderRadius: '50px' }}
              >
                Cancel
              </Button>
            </span>
          </Tooltip>
        </div>
        <div className={classes}>
          {activeStep !== 0 && (
            <Tooltip title="Go back to previous step">
              <span>
                <Button onClick={handleBack} variant="contained" className={classes} sx={{ borderRadius: '50px', mr: 0.5 }}>
                  Back
                </Button>
              </span>
            </Tooltip>
          )}
          {checkstate.checkedB ? (
            <Tooltip title={result > 0 ? "Proceed to the next step" : "Please complete all required fields"}>
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleClickConfirmation}
                  className={classes}
                  disabled={result > 0 ? false : true}
                  sx={{ borderRadius: '50px' }}
                >
                  Next
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Tooltip title="Proceed to the next step">
              <span>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handlesetClick}
                  className={classes}
                  sx={{ borderRadius: '50px' }}
                >
                  Next
                </Button>
              </span>
            </Tooltip>
          )}
        </div>
      </Box>
      <div style={{ alignItems: "center", display: "flex", width: "600px" }}>
        <Dialog
          open={confirmation}
          onClose={handleCloseConfirmation}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            The below applied specifications will get reflected on your machine{" "}
            <strong style={{ color: "#EF5350" }}>
              {localStorage.getItem("specifyusername")}
            </strong>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description"></DialogContentText>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel and close dialog">
              <span>
                <Button onClick={handleCloseConfirmation} variant="contained" color="secondary" sx={{ borderRadius: '50px' }}>
                  Cancel
                </Button>
              </span>
            </Tooltip>
            <Tooltip title="Apply specifications">
              <span>
                <Button onClick={handlesetClick} variant="contained" color="primary" autoFocus sx={{ borderRadius: '50px' }}>
                  Apply
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  );
}
